<template>
  <div :class="['quiz-meter', { 'is-invalid': !state }]">
    <div class="quiz-meter__inner">
      <a
        v-for="option in [0, 1, 2, 3, 4, 5]"
        :key="option"
        :data-qa="`cat-answer-${questionKey}-${option}`"
        :class="[
          'quiz-meter__btn',
          { selected: option === value },
          { first: option === 0 },
          { last: option === 5 },
        ]"
        @click="update({ name: questionKey, value: option })"
      >
        {{ option }}
      </a>
    </div>
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Number,
    default: null,
  },
  state: {
    type: Boolean,
    default: true,
  },
  update: {
    type: Function,
    required: true,
  },
  questionKey: {
    type: String,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
.quiz-meter {
  margin: 0 auto;

  &__inner {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
    margin-top: 15px;
  }

  &.is-invalid &__inner {
    box-shadow: 0 0 0 2px $kds-color-text-interactive-destructive;
    border-radius: 8px;
  }

  &__btn {
    min-width: 44px;
    width: 10%;
    height: 44px;
    display: block;
    text-decoration: none;
    text-align: center;
    background-color: $kds-color-background-subtle;
    background-position: center;
    line-height: 44px;
    border-radius: 0;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    @media (hover: hover) {
      &:hover {
        background-color: $kds-color-background-strong;
      }
    }

    &.first {
      border-radius: 8px 0 0 8px;
    }

    &.last {
      border-radius: 0 8px 8px 0;
    }

    &.btn {
      display: none;
    }

    &.selected {
      background: $kds-color-background-interactive-accent;
      color: $kds-color-text-primary-inverse;
      border-radius: 4px;
      position: relative;
      -webkit-box-shadow: 0 0 0 5px $kds-color-background-interactive-accent;
      -moz-box-shadow: 0 0 0 5px $kds-color-background-interactive-accent;
      box-shadow: 0 0 0 5px $kds-color-background-interactive-accent;
      transition: all 0.2s ease-in-out;
      font-weight: 500;

      @media (hover: hover) {
        &:hover {
          background-color: $kds-color-background-interactive-accent-hover;
          -webkit-box-shadow: 0 0 0 5px
            $kds-color-background-interactive-accent-hover;
          -moz-box-shadow: 0 0 0 5px
            $kds-color-background-interactive-accent-hover;
          box-shadow: 0 0 0 5px $kds-color-background-interactive-accent-hover;
        }
      }
    }
  }
}
</style>
